class QuickViewSubscription extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  // init() {
  //   // const productUrl = this.dataset.productUrl.split('?')[0];
  //   const productUrl = '/products/subscription-product';

  //   const sectionUrl = `${productUrl}?view=subscription-quickview`;
  //   const drawerContent = this.querySelector('.quick-view__content');
  //   console.log('tets', sectionUrl, productUrl, drawerContent)
  //   fetch(sectionUrl)
  //     .then(res => res.text())
  //     .then(responseText => {

  //       // Inject content after small delay
  //       setTimeout(() => {
  //         console.log('responseText',responseText);
  //         const doc = new DOMParser().parseFromString(responseText, 'text/html');
  //         console.log('doc',doc);
  //         const productElement = doc.querySelector('.quick-view__content');
  //         console.log('productElement',productElement)
  //         if (productElement) {
  //           drawerContent.innerHTML = productElement.innerHTML;
  //           console.log('-1-1-1-1', drawerContent.innerHTML);
  //           if (window.Shopify && Shopify.PaymentButton) {
  //             Shopify.PaymentButton.init();
  //           }
  //         } else {
  //           console.error('Subscription Quick View: No .quick-view__content found');
  //         }
  //       }, 200);

  //       // Remove loader / dispatch event
  //       setTimeout(() => {
  //         drawerContent.classList.remove('loading');
  //         document.dispatchEvent(new CustomEvent('quickview:loaded', {
  //           detail: { productUrl: productUrl }
  //         }));
  //       }, 500);
  //     })
  //     .catch(err => console.error('Subscription Quick View fetch failed:', err));
  // }

  init() {
  const productUrl = this.dataset.productUrl;
  const sectionUrl = `${productUrl}?view=subscription-quickview`;
  const drawerContent = this.querySelector('.quick-view__content');

  fetch(sectionUrl)
    .then(res => res.text())
    .then(responseText => {
      setTimeout(() => {
        const doc = new DOMParser().parseFromString(responseText, 'text/html');
        const productElement = doc.querySelector('.quick-view__content');
        if (productElement) {
          drawerContent.innerHTML = productElement.innerHTML;

          // Remove loader/hide classes
          drawerContent.classList.remove('loading', 'hide-cover');

          // Initialize Shopify payment buttons if needed
          if (window.Shopify && Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
          }
        } else {
          console.error('Subscription Quick View: No .quick-view__content found');
        }
      }, 200);
    })
    .catch(err => console.error('Subscription Quick View fetch failed:', err));
}

}

customElements.define('quick-view-subscription', QuickViewSubscription);
